<template>
<div class="body">
  <div class="contents navigation-line">
        <p class="navigation">
                    <i class="icon iconfont icon-yuanquan_huaban1"></i>
                    <span class="nowshow">当前位置：</span>                    
                    <router-link class="navigation-now" tag="a" :to="{ name: 'index'}">首页</router-link>
                    <i class="icon iconfont icon-youjiantou"></i>
                    <span class="navigation-now">产品</span>

        </p>
      <div class="contents">
          <div class="contents-left" :class="{'isFixed':whether}" id="contents-left">
              <p class="contents-left-title">
                  产品分类
              </p>
              <div class="contents-left-item" v-for="(info,index) in classlist">
                  <p class="contents-left-item-title"
                  @click="getclass(index,0)" :class="{'contents-left-item-title-active':info.selected}">
                  {{info.name}}
                  <img v-show="info.selected" src="/static/icon/icon-next2.png" />
                  <img v-show="!info.selected" src="/static/icon/icon-next.png" />
                  <!-- <i v-show="info.selected" class="icon iconfont icon-shixinjiantou-xiangshang"></i>
                  <i v-show="!info.selected" class="icon iconfont icon-shixinjiantou-xiangshang-copy"></i> -->
                   </p>
                  <ul class="contents-left-item-ul" v-show="info.selected">
                      <li v-for="(sinfo,sindex) in info.list" class="contents-left-item-li" @click="gotoClass(info.name,info.id,sinfo.id)" :class="{'active2':sinfo.selected}">
                          {{sinfo.name}}
                      </li>                  
                  </ul>
              </div>              
          </div>
          <div class="contents-right">
              <div class="contents-right-item" v-for="(info,index) in classlist" :id="'right'+index">
                  <p class="contents-right-item-title" :class="{'contents-right-item-title-active':info.selected}">
                      {{info.name}}
                  </p>

                  <ul class="contents-right-item-ul">
                        <router-link class="contents-right-item-li" v-for="(sinfo,sindex) in info.list" :key='sinfo.id' :to="{ name: 'goodslist', params: { pid: info.id,classid:sinfo.id,classname:info.name }}" tag='li'>
                            <img :src="sinfo.image">
                            <p>{{sinfo.name}}</p>
                        </router-link>
                  </ul>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
export default {
    data(){            
        return {
            classlist:[],
            whether:false,
            classid:this.$route.params.id
        }
    },
    methods: {
        getclasslist(){
            //重新获取数据   
            // const res = await this.$http.get(this.url)
            this.$api.goods.getClassAll(this.classid).then((res)=>{            
                this.classlist = res.data.datas;
                var index=this.classlist.findIndex((item)=>
                    { 
                        if(item.id == this.classid){
                            return true;
                        }
                    }           
                )
                this.$nextTick(function () {
                    this.getclass(index,0)
                })
                
            })
        },
        gotoClass(name,id,sid){
            this.$router.push({name:"goodslist",params: { pid: id,classid:sid,classname:name }})
        },
        getclass(index,sindex){
            for(var i in this.classlist){

                this.classlist[i].selected=false;

                for(var j in this.classlist[i].list){

                    this.classlist[i].list[j].selected=false;
                        
                }
            }
            if(sindex==0){
                    this.classlist[index].selected=true;
                    //this.classlist[index].list[0].selected=true;
            }else{
                    // console.log("开始了")
                    this.classlist[index].selected=true;
                    //this.classlist[index].list[sindex].selected=true;        
            }
            this.classid = this.classlist[index].id;
            
            var offsetTop = document.querySelector('#right'+index).offsetTop-50;

            window.scrollTo({
                top:offsetTop,
                behavior:"smooth"
            });
        },
        handleScroll () {
            //计算滚动条位置
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            //计算绑定div位置
            
            if(document.querySelector('#contents-left')!=null){
                var offsetTop = document.querySelector('#contents-left').offsetTop;
                //进行比较设置位置fixed
                this.whether = scrollTop > offsetTop;
            }
            
        },
    },
    mounted(){
        this.getclasslist();
        window.addEventListener('scroll', this.handleScroll);
    },
}
</script>
<style>
.body{
    background-color: #F3F5F7;
    overflow: hidden;
}
</style>
<style scoped>

.contents{
    overflow: hidden;
}
 .allbrand{
        color: #333333;
    }
.navigation{
    margin-bottom: 22px;
}
.contents .contents-left{
    width: 240px;
    box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
    border-radius: 5px;
    overflow: hidden;
    float:left;
    background-color: #fff;
}
.navigation-line{
    font-size: 16px;
    margin-top: 25px;
    
}
.contents-left-title{
    font-size: 24px;
    padding-left: 15px;
    padding-top: 13px;
    padding-bottom: 13px;
    /* margin-bottom: 10px; */
    font-size: 18px;
    border-bottom: 5px solid #f3f5f7;
}
.contents-left-item{
    cursor:pointer;
    border-bottom: 2px solid #f3f5f7;
}
.contents-left-item:last-child{
    border-bottom: none;
}
.contents-left-item .contents-left-item-title-active{
    /* height: 41px;
    line-height: 41px;
    font-size: 18px;
    box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.25);
    position: relative;
    padding-left:15px; */
}
.contents-left-item .contents-left-item-title{
    height: 41px;
    line-height: 41px;
    /* font-size: 18px; */
    padding-left:15px;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;

}
.contents-left-item .contents-left-item-title img{
    margin-right: 30px;
}
.contents-left-item-title .icon{
    font-size: 14px;
    float:right;
    margin-right: 30px;
    color: #999;
}
/* .contents-left-item .contents-left-item-title-active::after{
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 41px;
    content: '';
    background-color: #2655AE;
} */
.contents-left-item .contents-left-item-ul{
    padding-left:17px;
    background-color:#F6F7FB;
    padding-top:10px;
    padding-bottom: 10px;
}
.contents-left-item .contents-left-item-ul .contents-left-item-li{
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #666666;
}

.contents-left-item .contents-left-item-ul .contents-left-item-li.active{
    color:#2655AE
}
.contents-right{
    width:937px;
    float:right;
}
.contents-right .contents-right-item-title{
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    color: #666666;
    font-weight: 700;
    font-size: 16px;
    padding-left: 15px;
}
.contents-right .contents-right-item-title-active{
    position: relative;
}
.contents-right .contents-right-item-title-active::before{
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 50px;
    content: '';
    background-color: #2655AE;
}
.contents-right-item-ul{
    overflow: hidden;
}
.contents-right-item-ul .contents-right-item-li{
    width: 145px;
    height: 185px;
    text-align: center;
    overflow: hidden;
    padding-bottom:18px;
    margin-top:20px;
    margin-bottom:23px;    
    border-radius: 5px;
    margin-left:5px;
    margin-right:23px;
    float: left;
    cursor:pointer;
}
.contents-right-item-ul .contents-right-item-li:hover{
    box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
    color: #2655AE;
}

.contents-right-item-ul .contents-right-item-li img{
    width: 111px;
    height:111px;
    margin-top: 17px;
    margin-bottom: 23px;
}
.isFixed {
  position: fixed;
  top: 0;
  z-index: 1000;
}
    .navigation{
        float:right;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
    .nowshow{
        color: #666;
    }
    .navigation-now{
        color: #888;
    }
    .navigation a:hover{color:#2655ae;text-decoration:underline}
    .navigation .icon-yuanquan_huaban1{
        color: #fbb113;
    }
</style>


// WEBPACK FOOTER //
// src/views/class/index.vue